export default "__VITE_ASSET__dc60dd82__"